import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../style/About.css";
import "../style/homepage.css";
import Footer from "../components/Footer";
import Header from "../components/Header";

const About = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <main className="exclusive-about">
      <Header />

      <section className="exclusive-hero about-used-hero">
        <div className="hero-overlay"></div>

        <div className="exclusive-hero-content">
          <span className="eyebrow">{t("about.heroEyebrow")}</span>

          <h1>{t("about.heroTitle")}</h1>

          <p>{t("about.heroTextOne")}</p>

          <div className="hero-actions">
            <button
              type="button"
              className="primary-btn"
              onClick={() => navigate("/cars")}
            >
              {t("about.exploreCars")}
            </button>

            <button
              type="button"
              className="secondary-btn"
              onClick={() => navigate("/contact")}
            >
              {t("about.contactUs")}
            </button>
          </div>
        </div>
      </section>

      <section className="about-story-section">
        <div className="about-story-text">
          <span className="eyebrow dark">
            {t("about.aboutEyebrow")}
          </span>

          <h2>{t("about.aboutTitle")}</h2>

          <p>{t("about.aboutText")}</p>

          <button
            type="button"
            className="primary-btn"
            onClick={() => navigate("/contact")}
          >
            {t("about.contactUs")}
          </button>
        </div>

        <div className="about-story-image">
          <img
            src="https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=1200&q=80"
            alt={t("about.aboutTitle")}
          />
        </div>
      </section>

      <section className="vehicle-purchase-section">
        <div className="purchase-image">
          <img
            src="https://images.unsplash.com/photo-1551830820-330a71b99659?auto=format&fit=crop&w=1200&q=80"
            alt={t("about.purchaseTitle")}
          />
        </div>

        <div className="purchase-content">
          <span className="eyebrow dark">
            {t("about.purchaseEyebrow")}
          </span>

          <h2>{t("about.purchaseTitle")}</h2>

          <p>{t("about.purchaseText")}</p>

          <ul>
            <li>{t("about.fairValuation")}</li>
            <li>{t("about.fastProcess")}</li>
            <li>{t("about.quickResponse")}</li>
          </ul>

          <button
            type="button"
            className="primary-btn"
            onClick={() => navigate("/contact")}
          >
            {t("about.getOffer")}
          </button>
        </div>
      </section>

      <section className="why-choose-section">
        <span className="eyebrow dark">
          {t("about.whyEyebrow")}
        </span>

        <h2>{t("about.whyTitle")}</h2>

        <div className="why-grid">
          <div>
            <h3>{t("about.fairPricesTitle")}</h3>
            <p>{t("about.fairPricesText")}</p>
          </div>

          <div>
            <h3>{t("about.serviceTitle")}</h3>
            <p>{t("about.serviceText")}</p>
          </div>

          <div>
            <h3>{t("about.maintainedTitle")}</h3>
            <p>{t("about.maintainedText")}</p>
          </div>

          <div>
            <h3>{t("about.communicationTitle")}</h3>
            <p>{t("about.communicationText")}</p>
          </div>

          <div>
            <h3>{t("about.simpleProcessTitle")}</h3>
            <p>{t("about.simpleProcessText")}</p>
          </div>

          <div>
            <h3>{t("about.qualityVehiclesTitle")}</h3>
            <p>{t("about.qualityVehiclesText")}</p>
          </div>
        </div>

        <div className="why-btn-wrapper">
          <button
            type="button"
            className="primary-btn"
            onClick={() => navigate("/contact")}
          >
            {t("about.contactUs")}
          </button>
        </div>
      </section>

      <section className="about-contact-cta">
        <div>
          <span className="eyebrow">
            {t("about.contactEyebrow")}
          </span>

          <h2>{t("about.contactTitle")}</h2>

          <p>{t("about.contactText")}</p>
        </div>

        <button
          type="button"
          className="primary-btn"
          onClick={() => navigate("/contact")}
        >
          {t("about.contactUs")}
        </button>
      </section>

      <Footer />
    </main>
  );
};

export default About;